import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import GoogleMap from "@shared/v2/GoogleMap/GoogleMap";
import CustomOverlay from "../CustomOverlay";
import ListingCard from "../ListingCard";
import SearchMapMarker from "./SearchMapMarker";
import SearchMapViewportManager from "./SearchMapViewportManager";

const SearchMap = ({
  listings,
  viewedListings,
  onClickListing,
  onToggleShare,
  maxListingsSelected,
  onUserDragMap,
  selectedListings,
}) => {
  const [selectedListing, setSelectedListing] = useState(null);
  const mappableListings = listings.filter((listing) => listing.lat != null && listing.lng != null);
  const activeListing = selectedListing == null ? null : mappableListings[selectedListing];

  const deselectListing = () => {
    onClickListing(null);
    setSelectedListing(null);
  };

  const onClickMarker = (index) => {
    if (index === selectedListing) {
      deselectListing();
      return;
    }

    onClickListing(mappableListings[index].blossorId);
    setSelectedListing(index);
  };

  useEffect(() => {
    deselectListing();
  }, [listings]);

  return (
    <div className="tw-h-full tw-mb-[8px]">
      <GoogleMap
        enableTerraCtrl={false}
        onChange={() => {}}
        mapProps={{
          className: "tw-w-full tw-h-full tw-rounded-[8px] tw-overflow-hidden",
          defaultCenter: { lat: 48.45, lng: -122.29 },
          defaultZoom: 11,
          mapTypeId: "roadmap",
          disableDefaultUI: true,
          zoomControl: true,
          clickableIcons: false,
        }}
      >
        <SearchMapViewportManager
          listings={listings}
          onClick={deselectListing}
          onUserDragMap={onUserDragMap}
        />
        {mappableListings.map((listing, index) => (
          <CustomOverlay
            key={listing.blossorId}
            position={{ lat: listing.lat, lng: listing.lng }}
            pixelOffset={{ x: -32, y: -34 }}
            zIndex={selectedListing === index ? 10 : "initial"}
          >
            <SearchMapMarker
              price={listing.price}
              onClick={() => onClickMarker(index)}
              isSelected={selectedListing === index}
              viewed={viewedListings.includes(listing.blossorId)}
            />
          </CustomOverlay>
        ))}
        {activeListing && (
          <CustomOverlay
            position={{ lat: activeListing.lat, lng: activeListing.lng }}
            pixelOffset={{ x: -118, y: -252 }} // This offset is to account for the ListingMarker
            allowReposition
            elementSize={{ width: 235, height: 214 }}
          >
            <ListingCard
              key={activeListing.blossorId}
              listing={activeListing}
              onToggleShare={onToggleShare}
              maxListingsSelected={maxListingsSelected}
              isChecked={selectedListings.some((l) => l.blossorId === activeListing.blossorId)}
              size="small"
            />
          </CustomOverlay>
        )}
      </GoogleMap>
    </div>
  );
};

SearchMap.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  viewedListings: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onClickListing: PropTypes.func.isRequired,
  onToggleShare: PropTypes.func.isRequired,
  maxListingsSelected: PropTypes.number.isRequired,
  onUserDragMap: PropTypes.func.isRequired,
  selectedListings: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default SearchMap;
